/**
 * Snowboard Addiction — window.load sold-out UI mitigation
 * Source: snippets/product-form.liquid ~428–440 (Story v3.1 export, known-good)
 *
 * Story selectors are listed first. Analog equivalents:
 * [data-sa-sold-out], [data-sa-purchase="add"] button.
 * Reads orphan input[name="id"] only (Liquid default variant).
 * Known limitation: can disagree with regional select — preserve behaviour when migrating.
 */
window.addEventListener('load', function () {
  const selectedId = document.querySelector('input[name="id"]')?.value;
  const inv = window.VariantInventory?.[selectedId] || 0;
  if (inv > 0) {
    document
      .querySelectorAll(
        '.product__submit--sold-out, .sold-out-badge, .out-of-stock-message, [data-sa-sold-out]'
      )
      .forEach((el) => {
        el.classList.remove('product__submit--sold-out', 'opacity-50');
        el.style.display = '';
      });
    const btn = document.querySelector('.product__submit__add, [data-sa-purchase="add"] button');
    if (btn) {
      btn.disabled = false;
      btn.classList.remove('opacity-50');
    }
  }
});
